import { HttpResponse } from '@angular/common/http';
import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FileDownloadService} from '@services/file-download.service';
import {FilenameParser} from '@utils/FilenameParser';
import {take, takeUntil} from 'rxjs/operators';
import {DevolucoesService} from 'src/app/services/devolucoes.service';
import { UntypedFormControl, FormsModule } from '@angular/forms';
import {ReplaySubject, Subject} from 'rxjs';
import {CustomSelectOption} from '../../components/select-one/custom-select-option';
import {BaseFormService} from '@services/base-form.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertSucessoPadraoComponent } from '../../components/alert-sucesso-padrao/alert-sucesso-padrao.component';
import { AlertErroPadraoComponent } from '../../components/alert-erro-padrao/alert-erro-padrao.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SomenteNumerosDirective } from '../../directives/somente-numeros.directive';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepickerToggleIcon, MatDatepicker } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { IconCalendarComponent } from '../../components/icon-calendar/icon-calendar.component';
import { MatButton } from '@angular/material/button';
import { IconFilterComponent } from '../../components/icon-filter/icon-filter.component';
import { SemResultadosComponent } from '../../components/sem-resultados/sem-resultados.component';
import { PaginacaoComponent } from '../../components/paginacao/paginacao.component';
import { NgClass, AsyncPipe, CurrencyPipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CpfPipe } from '../../pipes/cpf.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-devolucoes',
    templateUrl: './devolucoes.component.html',
    styleUrls: ['./devolucoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, AlertSucessoPadraoComponent, AlertErroPadraoComponent, BreadcrumbComponent, SelectOneComponent, MatFormField, MatLabel, MatPrefix, MatInput, SomenteNumerosDirective, FormsModule, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatIcon, MatDatepickerToggleIcon, IconCalendarComponent, MatDatepicker, MatButton, IconFilterComponent, SemResultadosComponent, PaginacaoComponent, NgClass, FooterComponent, AsyncPipe, CurrencyPipe, NgxPaginationModule, CamelCasePipe, CpfPipe, UsuarioPermissaoPipe, AppDatePipe]
})
export class DevolucoesComponent extends BaseFormService implements OnInit {

  private idEmpresaLogada: string;
  public pagina = 0;
  public tamanho = '5';
  public devolucoes: any = 0;
  public situacoes: any = null;
  usuarios: ReplaySubject<CustomSelectOption[]> = new ReplaySubject<CustomSelectOption[]>(1);
  public idUsuarioDevolucao: any = null;
  public numeroPedido: any = null;
  public dataEmissao: any = null;
  public tipoDevolucao: any = null;
  public itensPaginacao: Array<any> = [];
  usuarioSelecionado: null;
  filtroBuscaUsuarios: UntypedFormControl = new UntypedFormControl('');
  protected onDestroyComponent = new Subject<void>();
  loadingGenerico = false;
  totalItems = 0;
  alertSucesso = false;
  alertErro = false;
  descricaoErro: any;
  paginaApi = 0;

  constructor(private readonly service: DevolucoesService) {
    super();
  }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.filtroBuscaUsuarios.valueChanges
      .pipe(takeUntil(this.onDestroyComponent))
      .subscribe(() => {
        this.filtrarUsuarios();
      });
  }

  getAllDevolucoes() {
    this.loadingGenerico = true;
    this.service.getAllDevolucoes(this.idEmpresaLogada,
      this.paginaApi,
      this.tamanho,
      this.idUsuarioDevolucao,
      this.numeroPedido,
      this.dataEmissao,
      this.tipoDevolucao)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            if (response.response?.dados?.length) {
              this.devolucoes = response.response;
              this.totalItems = response.response.pageInfo.totalRegistros;
            } else {
              this.devolucoes = undefined;
              this.totalItems = 0;
            }
          } else {
            this.devolucoes = undefined;
            this.totalItems = 0;
          }
          this.loadingGenerico = false;
        },
        error: (erro: any) => {
          console.error(erro);
          this.loadingGenerico = false;
          this.alertErro = true;
          this.descricaoErro = 'Não foi possível filtrar devoluções. Tente novamente, caso o erro persista tente novamente mais tarde.';
          this.devolucoes = false;
        }
      });
  }

  filtrarUsuarios() {
    if (this.filtroBuscaUsuarios.value.length > 3) {
      this.loadingGenerico = true;
      let campoSemCaracteres = this.filtroBuscaUsuarios.value;
      campoSemCaracteres = campoSemCaracteres.replace('.', '').replace('-', '').replace('.', '');
      if (campoSemCaracteres.length > 3) {
        this.service.getUsuarios(this.idEmpresaLogada, campoSemCaracteres).pipe(take(1)).subscribe({
          next: (response: any) => {
            if (response.response) {
              this.usuarios.next(this.mapearResultados(response.response, 'idUsuario', 'nomeUsuario'));
            } else {
              this.usuarios.next(null);
            }
            this.loadingGenerico = false;
          },
          error: (erro: any) => {
            this.loadingGenerico = false;
            this.alertErro = true;
            this.descricaoErro = 'Não foi possível filtrar usuários. Tente novamente, caso o erro persista tente novamente mais tarde.';
          }
        });
      }
    }
  }

  filtrarDevolucoes() {
    if (this.idUsuarioDevolucao || this.tipoDevolucao !== null || this.dataEmissao || this.numeroPedido) {
      this.pagina = 0;
      this.getAllDevolucoes();
    }
  }

  alteraQuantidadePorPagina(event: any) {
    this.pagina = 0;
    this.tamanho = event;
    this.getAllDevolucoes();
  }

  abreFecharResolucao(indexInconsistencia: any) {
    const flechaResolucao = document.querySelector('#flechaResolucao' + indexInconsistencia);
    const colunaResolucao = document.querySelector('#colunaResolucao' + indexInconsistencia);

    if (flechaResolucao.classList.contains('fa-chevron-down')) {
      flechaResolucao.classList.remove('fa-chevron-down');
      flechaResolucao.classList.add('fa-chevron-up');
      colunaResolucao.classList.remove('d-none');
    } else {
      flechaResolucao.classList.remove('fa-chevron-up');
      flechaResolucao.classList.add('fa-chevron-down');
      colunaResolucao.classList.add('d-none');
    }

  }

  downloadRelatorioCsv() {
    this.loadingGenerico = true;
    this.service.downloadRelatorioCompleto
    (this.idEmpresaLogada, this.idUsuarioDevolucao, this.numeroPedido, this.dataEmissao, this.tipoDevolucao).subscribe({
      next: ({ body, headers }: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.pdf',
        );
        FileDownloadService.download([body], filename);
        this.loadingGenerico = false;
        this.alertSucesso = true;
      },
      error: (erro: any) => {
        this.alertErro = true;
        this.descricaoErro = 'Não foi possível baixar seu relatório. Tente novamente, caso o erro persista tente novamente mais tarde.';
        this.loadingGenerico = false;
      }
    });
  }

  onChangeUsuario(event: any) {
    this.idUsuarioDevolucao = event;
  }

  campoFiltroPreenchido() {
    return this.idUsuarioDevolucao !== null ||
      this.numeroPedido !== null ||
      this.dataEmissao !== null ||
      this.tipoDevolucao !== null;
  }

  limparFiltro() {
    this.usuarios = null;
    this.idUsuarioDevolucao = null;
    this.numeroPedido = null;
    this.dataEmissao = null;
    this.devolucoes = 0;
    this.tipoDevolucao = null;
    this.pagina = 0;
  }

  alteraTipoDevolucao(event: any) {
    this.tipoDevolucao = event;
  }

  getPageDevolucao(event: number) {
    this.pagina = event;
    this.paginaApi = event - 1;
    this.getAllDevolucoes();
  }

  sucessoFechou() {
    this.alertSucesso = false;
  }

  alertErroFechou() {
    this.alertErro = false;
  }
}
